import { EMPLOYEE_DETAILS_ACTIONS } from 'Actions/index';

const initialState = {
  name: '',
  designation: '',
  contact: '',
  alternateContact: '',
  employeeId: '',
  email: '',
  origin: '',
  destination: '',
  allowance: 0,
  status: '',
  hrDetails: {
    name: '',
    email: '',
  },
  services: [],
  invoices: [],
};

const { SET_EMPLOYEE_INFO } = EMPLOYEE_DETAILS_ACTIONS;

const employeeDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMPLOYEE_INFO:
      return {
        ...initialState,
        contact: action.payload.contactNumber,
        alternateContact: action.payload.alternateContactNumber,
        joiningDate: action.payload.joiningDate,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default employeeDetails;
